module.exports = __webpack_public_path__ + "img/south_side_1.ad9fdca3.jpg";